import { BaseReportReason, type ReportType } from '@/core/data/report/report.type';
import { GamSwitchValueType } from '@/views/composables/constants/components/gamSwitch.constants';
import type { GamSwitchType } from '@/views/composables/models/components/GamSwitch';

export default class ReportHelper {
  static getReportReasons(type: ReportType): GamSwitchType[] {
    return Object.values(BaseReportReason).map((value) => ({
      type: GamSwitchValueType.RADIO,
      label: `dialog.report.reason.${value}`,
      name: type,
      value,
    }));
  }
}
